export default "__VITE_ASSET__CZCvqyHN__"